// 查询单价
export function queryUnitPrice(priceCfg, num = 0) {
    for (const curCfg of priceCfg) {
        if (
            (curCfg.min === '' && num <= curCfg.max) ||
            (num >= curCfg.min && num <= curCfg.max) ||
            (curCfg.max === '' && num >= curCfg.min)
          ) {
            return curCfg.price;
          }
    }
    return priceCfg[0].price;
}